module.exports = __webpack_public_path__ + "static/media/arrow_w.db8f050f.svg";